/**
 * Utilities for working with Promises
 * @module
 */
var _ = require('optimizely-client-fn');
var PromiseEnv = require('../lib/promise').Promise;

/**
 * Resolve with the resolution of the first promise to resolve, ignoring rejections
 * (unlike PromiseEnv.race which rejects if any Promise rejects).
 *
 * @param {Array.<Promise>} promises - array of values which may or may not be promises. Like PromiseEnv.all, calls PromiseEnv.resolve to "upgrade" values to Promise
 * @returns {Promise} resolves when first promise in argument list resolves
 */
exports.firstToResolve = function(promises:Promise<any>[]): Promise<any> {
  return new PromiseEnv(function(resolve) {
    _.each(promises, function(promise) {
      // throw away rejected promises, resolve if any resolves
      PromiseEnv.resolve(promise).then(resolve, function() {});
    });
  });
};
